<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">所属学习班：</div>
        <div class="form_box__group__item__content">{{info.studyClassName}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">所属开班单位/党组织：</div>
        <div class="form_box__group__item__content">{{info.createunit}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">课程学时：</div>
        <div class="form_box__group__item__content">{{info.credithour}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">排课状态：</div>
        <div class="form_box__group__item__content">{{info.shedulStatus}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">排课详细信息：</div>
        <div class="form_box__group__item__content">{{info.day}}</div>
      </div>
      <div class="form_box__group__item" v-for="item in info.courses" :key="item.id">
        <div class="form_box__group__item__title">绑定的课程：</div>
        <div class="form_box__group__item__content bindingClass">{{item.title}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">总参与人数</div>
        <div class="form_box__group__item__content">{{stat.totalNum}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">获取学分人数</div>
        <div class="form_box__group__item__content">{{stat.checkedNum}}</div>
      </div>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">未获取学分人数</div>
        <div class="form_box__group__item__content">{{stat.unCheckedNum}}</div>
      </div>
    </el-card>

    <el-card class="box-card">
      <el-table 
        :data="datas" 
        style="width: 100%">
        <el-table-column type="index" :index="indexMethod"></el-table-column>
        <el-table-column label="学员" prop="name"></el-table-column>
        <el-table-column label="签到状态" prop="checkedStr"></el-table-column>
        <el-table-column label="阶段状态" prop="statusStr"></el-table-column>
        <el-table-column label="报名时间" prop="applydateStr"></el-table-column>
        <el-table-column label="签到时间" prop="signindateStr"></el-table-column>
        <el-table-column label="签退时间" prop="signoutdateStr"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>


<script>
import { ExportStudyClassBtn } from "@/views/module/export/comp";
import { classPlanDetailApi } from "@/api/module/studyclass/studyclass";

export default {
  name: "studyclass-hours-detail",

  components: {
    ExportStudyClassBtn
  },
  data() {
    return {
      uid : "",
      tableData : [],
      stat: '', //统计信息
      info : "", //简介信息
      datas : [], //列表信息
    }
  },
  methods:{
    getclassPlanDetail() {
      let data = {
        sid: this.uid,
      }

      classPlanDetailApi(data)
        .then((res) => {
          console.log(res);
          this.info = res.detail;
          this.datas = res.list;
          this.stat = res.stat;
        })
    },

    indexMethod(index) {
          return index + 1 ;
    }
  },
  created() {
    this.uid = this.$route.query.id;
    this.getclassPlanDetail();
  }
}

</script>






<style scoped lang='scss'>
.box-card {
  margin-bottom: 20px;
  .userName {
    padding-left: 10px;
    margin-bottom: 10px;
    .title {
      color: #303133;
      font-size: 14px;
      font-weight: 500;
      display: inline-block;
      width: 70px;
    }
    .cont {
      font-size: 14px;
      color: #3e3e3e;
    }
  }
}
.clearfix {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}
.el-pagination {
  text-align: center;
  margin-top: 30px;
}
.form_box__group__item__title {
  width: 150px;
}
.bindingClass {
  display: flex;
  flex-direction: column;
}
</style>